export enum OrderType {
    physicianOrder = 1,
    medicationProfile = 2,
}
